export default "__VITE_ASSET__98d67tPf__"